import React from 'react';
import { InitiativeDashboardKPIs } from './types';

interface Props {
  kpis: InitiativeDashboardKPIs | null;
}

export const InitiativesMetricsCards: React.FC<Props> = ({ kpis }) => {
  if (!kpis) return null;

  return (
    <div className="stats-grid">
      <div className="stat-card">
        <span className="stat-label">Total Initiatives</span>
        <span className="stat-value" style={{ color: '#0f172a' }}>{kpis.total_initiatives}</span>
        <span className="stat-sub">{kpis.active_initiatives} In Active Execution</span>
      </div>

      <div className="stat-card">
        <span className="stat-label">Health Status (On Track)</span>
        <span className="stat-value" style={{ color: '#059669' }}>{kpis.on_track_count}</span>
        <span className="stat-sub">Average Health Score: {kpis.average_health_score}/100</span>
      </div>

      <div className="stat-card">
        <span className="stat-label">Risk & Critical Status</span>
        <span className="stat-value" style={{ color: kpis.critical_count > 0 ? '#dc2626' : '#d97706' }}>
          {kpis.at_risk_count + kpis.critical_count}
        </span>
        <span className="stat-sub">{kpis.critical_count} Critical Escalations</span>
      </div>

      <div className="stat-card">
        <span className="stat-label">Average Progress</span>
        <span className="stat-value" style={{ color: '#2563eb' }}>%{kpis.average_progress_percentage}</span>
        <span className="stat-sub">{kpis.completed_count} Completed Successfully</span>
      </div>

      <div className="stat-card">
        <span className="stat-label">Actual Expenditure</span>
        <span className="stat-value" style={{ color: '#0f172a' }}>
          ${kpis.total_actual_cost.toLocaleString()}
        </span>
        <span className="stat-sub">Budget: ${kpis.total_allocated_budget.toLocaleString()}</span>
      </div>

      <div className="stat-card">
        <span className="stat-label">Critical Milestones & Actions</span>
        <span className="stat-value" style={{ color: '#4f46e5' }}>
          {kpis.critical_path_milestones_count} / {kpis.linked_central_actions_count}
        </span>
        <span className="stat-sub">Critical Path & Linked Actions</span>
      </div>
    </div>
  );
};
